import { render, staticRenderFns } from "./UnitaMobiliSelect.vue?vue&type=template&id=5ec78404&"
import script from "./UnitaMobiliSelect.vue?vue&type=script&lang=js&"
export * from "./UnitaMobiliSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports